import {
    useRacesLoader,
    useStationsLoader,
    useStationRolesLoader,
    usePointTypesLoader,
    useCategoriesLoader,
    useGroupsLoader,
    useFederationsLoader,
    useOrganizersLoader,
    useIDTypesLoader,
    useCountriesLoader,
    useClubsLoader,
    useEventTeamsLoader,
    useLicencesLoader,
    useContestantsLoader,
    useActiveTimesLoader,
    useEventImplementationsLoader,
    useRelayContestantsLoader,
    useStationTypesLoader,
    useTracksLoader,
    useHeatplanLoader,
} from '.';
import { useChronoTracksLoader } from './chronoTracksLoader';
import { useBibAssignLoader } from './bibAssignLoader';
import { useEventLoader } from './eventLoader';
import { useGpiReadingsLoader } from './gpireadingsLoader';
import { useRegionsLoader } from './regionsLoader';

type LOADABLE =
    | 'RACES'
    | 'GROUPS'
    | 'STATIONS'
    | 'STATIONROLES'
    | 'POINTTYPES'
    | 'CATEGORIES'
    | 'EVENT'
    | 'FEDERATIONS'
    | 'IDTYPES'
    | 'ORGANIZERS'
    | 'COUNTRIES'
    | 'CHRONOTRACKS'
    | 'CLUBS'
    | 'LICENCES'
    | 'EVENTTEAMS'
    | 'CONTESTANTS'
    | 'RELAYCONTESTANTS'
    | 'ACTIVETIMES'
    | 'EVENTIMPLEMENTATIONS'
    | 'STATIONTYPES'
    | 'TRACKS'
    | 'BIBASSIGN'
    | 'REGIONS'
    | 'HEATPLAN'
    | 'GPIREADINGS';

export const useLoaders = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void, loadable: Array<LOADABLE>) => {
    loadable.forEach((l) => {
        switch (l) {
            case 'CHRONOTRACKS':
                useChronoTracksLoader(AddLoader);
                break;
            case 'EVENT':
                useEventLoader(AddLoader);
                break;
            case 'RACES':
                useRacesLoader(AddLoader);
                break;
            case 'CATEGORIES':
                useCategoriesLoader(AddLoader);
                break;
            case 'GROUPS':
                useGroupsLoader(AddLoader);
                break;
            case 'STATIONS':
                useStationsLoader(AddLoader);
                break;
            case 'STATIONROLES':
                useStationRolesLoader(AddLoader);
                break;
            case 'POINTTYPES':
                usePointTypesLoader(AddLoader);
                break;
            case 'FEDERATIONS':
                useFederationsLoader(AddLoader);
                break;
            case 'REGIONS':
                useRegionsLoader(AddLoader);
                break;
            case 'IDTYPES':
                useIDTypesLoader(AddLoader);
                break;
            case 'ORGANIZERS':
                useOrganizersLoader(AddLoader);
                break;
            case 'COUNTRIES':
                useCountriesLoader(AddLoader);
                break;
            case 'CLUBS':
                useClubsLoader(AddLoader);
                break;
            case 'EVENTTEAMS':
                useEventTeamsLoader(AddLoader);
                break;
            case 'CONTESTANTS':
                useContestantsLoader(AddLoader);
                break;
            case 'LICENCES':
                useLicencesLoader(AddLoader);
                break;
            case 'BIBASSIGN':
                useBibAssignLoader(AddLoader);
                break;
            case 'ACTIVETIMES':
                useActiveTimesLoader(AddLoader);
                break;
            case 'EVENTIMPLEMENTATIONS':
                useEventImplementationsLoader(AddLoader);
                break;
            case 'RELAYCONTESTANTS':
                useRelayContestantsLoader(AddLoader);
                break;
            case 'STATIONTYPES':
                useStationTypesLoader(AddLoader);
                break;
            case 'TRACKS':
                useTracksLoader(AddLoader);
                break;
            case 'HEATPLAN':
                useHeatplanLoader(AddLoader);
                break;
            case 'GPIREADINGS':
                useGpiReadingsLoader(AddLoader);
                break;
        }
    });
};
